import React, { useEffect, useState } from "react";
import "./ServiceHeader.css"; 
import header_img from "../../assets/serviceheader.jpg";



const ServiceHeader = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const headerStyle = {
    backgroundImage: `url(${header_img})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textAlign: 'center',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
  };

  return (
    <section className={`service-header ${isVisible ? "animate" : ""}`} style={headerStyle}>
      <div className="header-content">
        <h1>Our Services</h1>
        <p>At Akinex, we offer expert consultancy services alongside our metal manufacturing solutions. From market research and product design to supply chain, logistics, software development, and financial management, we help businesses streamline operations, optimize strategies, and stay ahead of industry trends.</p>
      </div>
    </section>
  );
};

export default ServiceHeader;